import { IClientSubclientServicepoint, IClientSubclientServicepointData } from "@/entities";

export class ClientSubclientServicepoint implements IClientSubclientServicepoint {
  readonly id?: number;
  readonly oidSol?: string;
  readonly codeSol?: string;
  readonly idSmartcash?: any;
  readonly uniqueCode?: any;
  readonly deviceId?: string;
  readonly description?: string;
  readonly address?: string;
  readonly active?: boolean;

  constructor(data: IClientSubclientServicepointData) {
    this.id = data.id;
    this.oidSol = data.oidSol;
    this.codeSol = data.codeSol;
    this.idSmartcash = data.idSmartcash;
    this.uniqueCode = data.uniqueCode;
    this.deviceId = data.deviceId;
    this.description = data.description;
    this.address = data.address;
    this.active = data.active;
  }
}
